// @flow

import _ from 'lodash';
import React, { type Node } from 'react';
import cx from 'classnames';

import Button from 'client/components/button/button';
import Loader from 'client/components/loader';
import Translate from 'client/components/translate';

import type { TranslateType } from 'types/translateType.flow';
import 'client/styles/funnel.scss';

type Props = {
  buttonClassName: string | null,
  children: Node | null,
  clickHandler: (e: SyntheticEvent<*>) => *,
  disabled: boolean,
  divStyle: string | null,
  forwardRef: HTMLButtonElement | null,
  isDisabled: boolean,
  isEde: boolean,
  isSubmitting: boolean,
  label: TranslateType | null,
  useLoader?: boolean,
  isIchra?: boolean,
};

export default function FunnelButton(props: Props) {
  const {
    buttonClassName,
    children,
    clickHandler,
    disabled,
    divStyle,
    forwardRef,
    isDisabled,
    isEde,
    isSubmitting,
    label,
    useLoader,
    isIchra,
  } = props;

  const renderTranslate = () =>
    (label ? (
      <Translate {...label} className={cx({ accessible: isEde })} />
    ) : (
      <Translate path="common.cta.continue" className={cx({ accessible: isEde })} />
    ));

  return (
    <div className={`${divStyle != null ? divStyle : 'text-center pad-y-3'}`}>
      {isSubmitting && useLoader === true ? (
        <Loader />
      ) : (
        <div
          className={cx({
            'funnel-button-container': !isIchra,
          })}>
          <Button
            forwardRef={forwardRef}
            clickHandler={clickHandler}
            type="submit"
            className={cx(
              `${isEde === true ? 'primary ede-cta' : 'cta-button'}`,
              {
                submitting: isSubmitting,
                disabled: disabled !== false || isDisabled,
              },
              buttonClassName,
            )}
            isDisabled={isDisabled}
            size="lg">
            {!_.isEmpty(children) ? children : renderTranslate()}
          </Button>
        </div>
      )}
    </div>
  );
}

FunnelButton.defaultProps = {
  buttonClassName: null,
  children: null,
  clickHandler: () => undefined,
  disabled: false,
  divStyle: null,
  forwardRef: null,
  isDisabled: false,
  isEde: false,
  label: null,
  useLoader: false,
  isIchra: false,
};
